import {ActiveOrderState} from '../../models';
import {makeActionCreator} from '../../redux-toolbelt';

export const setUserReportOrderDetails = makeActionCreator<'setUserReportOrderDetails', ActiveOrderState>(
  'setUserReportOrderDetails',
);
